<script>
export default {
  data() {
    return {
      
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="title text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/sign-warning-icon.png')" class="_w-m-300 mb-5" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Unknown error occurred</h3>
        <p class="text-muted" data-aos="fade-zoom-in">An unknown error occurred during the listing process. {{ app_name }} staff has been notified and are looking into the issue. Please avoid attempting to submit the listing a second time, as it is possible that your payment attempt may have been processed before the error occurred.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">
          
        </div>
        <div class="col-6 text-right">

        </div>
      </div>
    </form>
  </div>

</template>
